export default "https://cdn-static.gokick.com/assets/ac567471f1b9fb2f6cedfba22f3391469dbaa38e/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";